import { DeleteMenuItem } from "./DeleteMenu";
import { EditMenuItem } from "./EditMenu";

export function TableMenu() {}

TableMenu.Edit = EditMenuItem;
TableMenu.Delete = DeleteMenuItem;
